import styled from 'styled-components';

export const NavContainer = styled.div`
  z-index: 150;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: sticky;
  top: 0;
  background-color: #19191b;
  border-bottom: 1px solid #555555;
`;

export const NavItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1280px;
  padding: 15px 0px;
  max-height: 75px;
`;

export const MainLogo = styled.img`
  display: flex;
  height: 30px;
  margin: 6px 0px;
  align-self: center;
`;

export const ProfilePictureStyled = styled.img`
  border-radius: 100px;
  height: 40px;
  box-shadow: 0px 2px black;
  &:hover {
    cursor: pointer;
  }
`;

export const ConnectWalletButton = styled.button`
  font-family: 'Everett-Light';
  color: #19191b;
  font-size: 14px;
  border-radius: 100px;
  border: 1px solid #000;
  height: 45px;
  padding: 0px 20px;
  background-color: #fff;
  &:hover {
    cursor: pointer;
  }
`;

export const DropdownMenu = styled.div`
  z-index: 1000;
  position: absolute;
  top: 70px;
  right: -20px;
  padding: 13px 20px;
  border-radius: 8px;
  background-color: #ffffff;
  opacity: 0.8;
  animation: fadeIn 1s;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.8;
    }
  }
`;
